import 'core-js/stable';
import 'regenerator-runtime/runtime';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import Router from '@/router';
import '@/styles/main.scss';
import '@/styles/reset.scss';

// 导入UnoCSS样式
import 'virtual:uno.css';

import { initAnalytics, report, EVENTTYPES } from '@/utils/analytics';

initAnalytics();
report({
  event_type: EVENTTYPES.PAGE_SHOW,
  event_id: 'website_view',
});

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container!);
root.render(
  <BrowserRouter basename="/">
    <Router />
  </BrowserRouter>,
);
